<template>
  <el-upload
    ref="elUpload"
    action=""
    :limit="1"
    style="display: none;"
    :accept="accept"
    :show-file-list="false"
    :http-request="handleHttpRequest"
  >
    <i ref="upload"></i>
  </el-upload>
</template>

<script>
export default {
  name: 'UploadNew',
  props: {
    callback: Function,
    accept: { type: String, default: '.pdf,.doc,.docx,.xlsx,.xls' },
    action: {
      type: String,
      default: 'account/uploadfile'
    }
  },
  data() {
    return {
      options: {},
      customHttp: null
    }
  },
  methods: {
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      for (const key in this.options) {
        formData.append(key, this.options[key])
      }
      if (this.customHttp) {
        this.customHttp(formData)
        this.$refs.elUpload.clearFiles()
        return
      }
      this.loading = true
      this.$store.dispatch(this.action, {
        payload: formData,
        success: (res) => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.callback && this.callback(this.options, res.data.viewUrl + res.data.filepath)
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    upload(row = {}, customHttp = null) {
      this.options = row
      this.customHttp = customHttp
      setTimeout(() => {
        this.$refs.upload.click()
      }, 20)
    }
  }
}
</script>

<style>

</style>
